import { Navigate, Outlet, createBrowserRouter, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { useEffect } from 'react'
import { wrapCreateBrowserRouterV6 } from '@sentry/react'

import { Header } from 'components/Header/Header'
import { GlobalBanner } from 'components/GlobalBanner/GlobalBanner'
import { LandingPage } from 'modules/LandingPage/LandingPage'
import { VaultDetails } from 'modules/VaultDetails/VaultDetails'
import { VaultsContainer } from 'modules/Vaults/VaultsContainer'
import { Footer } from 'components/Footer/Footer'
import { frozenVaults, vaultDisplayInfoList } from './vaultDisplayInfo'
import { LpVaultsContainer } from 'modules/LpVaults/LpVaultsContainer'
// import { Dashboard } from 'modules/Dashboard/DashboardContainer'
import { LpVaultDetails } from 'modules/LpVaultDetails/LpVaultDetails'
import { PAIR_INFOS } from 'utils/pair-info'
import { Leaderboard } from 'modules/Leaderboard/Leaderboard'
import { TermsOfUse } from 'modules/TermsOfUse/TermsOfUse'
import { PrivacyPolicy } from 'modules/PrivacyPolicy/PrivacyPolicy'
import { TermsAcceptance } from 'modules/TermsAcceptance/TermsAcceptance'

import { ROUTES } from './route-constants'

const Wrapper = styled.div`
  @media screen and (min-width: ${p => p.theme.breakpoints.md}px) {
    background: ${p => p.theme.colors.gradients.pageBackgroundGradient};
  }
`

const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

const HeaderLayout = () => {
  return (
    <Wrapper>
      <TermsAcceptance />
      <GlobalBanner />
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
    </Wrapper>
  )
}

const sentryCreateBrowserRouter = wrapCreateBrowserRouterV6(createBrowserRouter)

export const router: ReturnType<typeof createBrowserRouter> = sentryCreateBrowserRouter([
  {
    path: '/',
    element: <HeaderLayout />,
    children: [
      {
        path: `/${ROUTES.VAULTS}`,
        element: (
          <>
            <Header />
            <VaultsContainer />
          </>
        ),
      },
      {
        path: `/${ROUTES.LP_VAULTS}`,
        element: (
          <>
            <Header />
            <LpVaultsContainer />
          </>
        ),
      },
      {
        path: `/${ROUTES.LEADERBOARD}`,
        element: (
          <>
            <Header />
            <Leaderboard />
          </>
        ),
      },
      // {
      //   path: `/${ROUTES.DASHBOARD}`,
      //   element: (
      //     <>
      //       <Header />
      //       <Dashboard />
      //     </>
      //   ),
      // },
      ...vaultDisplayInfoList.map(vaultDisplayInfo => ({
        path: `/${ROUTES.VAULTS}/${vaultDisplayInfo.tSymbol}`,
        element: <VaultDetails displayInfo={vaultDisplayInfo} />,
      })),
      ...frozenVaults.map(vaultDisplayInfo => ({
        path: `/${ROUTES.VAULTS}/frozen/${vaultDisplayInfo.tSymbol}`,
        element: <VaultDetails displayInfo={vaultDisplayInfo} />,
      })),
      ...PAIR_INFOS.map(pair => ({
        path: `/${ROUTES.LP_VAULTS}/${pair.coinX.displaySymbol}-${pair.coinY.displaySymbol}`,
        element: <LpVaultDetails pairInfo={pair} />,
      })),
      {
        path: `/${ROUTES.TERMS}`,
        element: <TermsOfUse />,
      },
      {
        path: `/${ROUTES.PRIVACY_POLICY}`,
        element: <PrivacyPolicy />,
      },
      {
        path: '/',
        element: <LandingPage />,
      },
      { path: '*', element: <Navigate to="/" /> },
    ],
  },
])
